import FloorModel from '@/_models/FloorModel'
import { Constant } from '@/_services/constant'

export const rotate = (x, y, xm, ym, a) => {
  const cos = Math.cos
  const sin = Math.sin

  const a1 = a * Math.PI / 180
  const xr = (x - xm) * cos(a1) - (y - ym) * sin(a1) + xm
  const yr = (x - xm) * sin(a1) + (y - ym) * cos(a1) + ym

  return [xr, yr]
}
